import React, { useEffect } from 'react';
import Button from '@material-ui/core/Button';
// import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
// import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import SearchCoin from './SearchCoin'
import { makeStyles } from '@material-ui/core/styles';
// import useMediaQuery from '@material-ui/core/useMediaQuery';
import { InputAdornment, FormControl, TextField, IconButton, Switch, FormControlLabel } from '@material-ui/core';
import DeleteForever from '@material-ui/icons/DeleteForever';
import red from '@material-ui/core/colors/red';



const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
    },
    dialogContent: {
        textAlign: "center",
        overflowY: 'visible',
        display: 'flex',
        flexWrap: 'wrap',
    },
    dialog: {
        overflowY: 'visible',
        display: 'flex',
        flexDirection: 'column',
    },
    search: {
        zIndex: 2000,
        position: 'absolute',
    },
    formControl: {
        margin: theme.spacing(1),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: red[500],
    },
}));


export default function FormDialog({
    open,
    setOpen,
    addCoin,
    removeCoin,
    fullScreen,
    coinSelected,
    idCardSelected,
    idBase }) {

    const classes = useStyles();

    // const [open, setOpen] = React.useState(true);

    const [coin, setCoin] = React.useState(null);
    const [volume, setVolume] = React.useState();
    const [base, setBase] = React.useState(false);
    // const [idCard, setIdCard] = React.useState(null);


    useEffect(() => {
        if (coinSelected != null) {
            let decimals = coinSelected.cripto ? 8 : 2
            setVolume(coinSelected != null ? parseFloat(coinSelected.conversaoHoje.volume).toFixed(decimals) : '')
            setBase(idBase === idCardSelected)
        } else {
            setVolume('')
            setBase(false)
        }
        setCoin(coinSelected)

        // console.log('coinSelected: ', coinSelected);

    }, [coinSelected])




    // function handleClickOpen() {
    //     setOpen(true);
    // }

    function handleClose() {
        setOpen(false);
        clean()
    }

    const clean = () => {
        setVolume('')
        setCoin(null)
        setBase(false)
    }

    // function handleChange(event) {
    //     setVolume(event.target.value);
    // }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullScreen={fullScreen}
            fullWidth
            scroll='body'
            maxWidth='sm'
            className={classes.dialog}
            aria-labelledby="max-width-dialog-title"
        >
            <DialogTitle id="max-width-dialog-title">
                {
                    coin !== null ?
                        <>
                            Editar Moeda
                            <IconButton aria-label="Close" className={classes.closeButton} onClick={() => {
                                removeCoin(coin)
                                handleClose()
                            }}>
                                <DeleteForever />
                            </IconButton>
                        </>
                        :
                        'Adicionar novo'
                }

            </DialogTitle>

            <DialogContent className={classes.dialogContent}>
                {/* <DialogContentText>
                    To subscribe to this website, please enter your email address here. We will send updates
                    occasionally.
                </DialogContentText> */}
                <FormControl className={classes.formControl} fullWidth>
                    <SearchCoin coin={coin} setCoin={setCoin} className={classes.search} />

                    <br />

                    <TextField
                        label="Quantidade"
                        id="volume"
                        type="number"
                        value={volume}
                        // onChange={e => handleChange(e)}
                        onChange={(e) => setVolume(e.target.value)}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">{coin ? coin.symbol : ''}</InputAdornment>,
                        }}
                    />

                    <br />

                    <FormControlLabel
                        control={
                            <Switch
                                checked={base}
                                onChange={(e) => setBase(e.target.checked)}
                                value="base"
                                color="primary"
                            />
                        }
                        label="Usar como base"
                    />
                </FormControl>

            </DialogContent>

            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Voltar
                </Button>
                <Button
                    onClick={() => {
                        handleClose()
                        addCoin(coin, volume, idCardSelected, base)
                        clean()
                    }}
                    color="primary"
                    disabled={!coin}
                >
                    Salvar
                </Button>
            </DialogActions>
        </Dialog >
    );
}